import { v4 as uuidv4 } from 'uuid';
import { Point } from '../utils/point';
import { ConfigurationCutting } from './configuration-cutting';
import { ConfigurationSideCut } from './configuration-side-cut';

export class ConfigurationSplashback {
  // Info basique
  id?: uuidv4; // Front only
  length: number;
  height: number;
  displayOrder: number;

  // Ids
  configurationPlanId: string;
  // Jointure
  origin: Point;
  configurationCuttings: ConfigurationCutting[];
  configurationSideCuts: ConfigurationSideCut[];

  // Info front uniquement
  startPoint?: Point;
  endPoint?: Point;
  isOnlySplashback: boolean = false;

  constructor(startPoint: Point, endPoint: Point, displayOrder: number, height: number, isOnlySplashback: boolean) {
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    this.calculateLength();
    this.displayOrder = displayOrder;
    if (height == null) {
      this.height = 350;
    } else {
      this.height = height;
    }
    this.configurationCuttings = [];
    this.configurationSideCuts = [];
    this.isOnlySplashback = isOnlySplashback;
  }

  private calculateLength() {
    let length = 0;

    const x = (this.endPoint.x - this.startPoint.x) ** 2;
    const y = (this.endPoint.y - this.startPoint.y) ** 2;
    length = Math.sqrt(x + y);

    this.length = Math.round(Math.abs(length));
  }
}

export function isHeightValid(splashback: ConfigurationSplashback): boolean {
  return splashback.height > 0;
}
